<template>
  <div class="main-content">
    <div class="wrap-content container" id="container">
      <!-- start: PAGE TITLE -->
      <section id="page-title" style="background-color: #d1d1d1;">
        <div class="row">
          <div class="col-sm-10">
            <h1 class="mainTitle">Deleted Doctors</h1>
          </div>
          <div class="col-sm-2">
            <router-link class="btn btn-primary" :to="{ name: 'all-doctors' }">Back</router-link>
          </div>
        </div>
      </section>
      <!-- end: PAGE TITLE -->
      <!-- start: DYNAMIC TABLE -->
      <div class="container-fluid container-fullw bg-white">
        <div class="row">
          <div class="col-md-12">

            <div v-if="doctors.length > 0">
              <MyTable :columns="columns" :actions="true">
                <tr v-for="(doctor, index) in filteredDoctors" :key="index">
                  <th scope="row">{{ doctor.id }}</th>
                  <td>{{ doctor.name }}</td>
                  <td>{{ doctor.title_ar }}</td>
                  <td>{{ doctor.title_en }}</td>
                  <td>
                    <img :src="doctor.main_image" width="50" height="50" class="img-thumbnail" />
                  </td>
                  <td>
                    <button class="me-2 btn btn-success" @click="restoreDoctor(doctor.id)">
                      Restore
                    </button>

                  </td>
                </tr>
              </MyTable>
            </div>
            <div v-else class="alert alert-info">
              No deleted doctors found.
            </div>
          </div>
        </div>
      </div>
      <!-- end: DYNAMIC TABLE -->
    </div>
  </div>
</template>

<script>
import axios from "../../Axios";
import $ from 'jquery'; // Import jQuery
import MyTable from "../MyTable//MyTable.vue"; // Import your MyTable component

export default {
  name: "DeletedDoctors",

  components: {
    MyTable,
    // Paginate,
  },

  data() {
    return {
      dataTable: [], // Store DataTable instance
      doctors: [],
      meta: {},
      searchTerm: "",
      columns: [
        { label: '#', key: 'id' },
        { label: 'Name', key: 'name' },
        { label: 'title Arabic', key: 'title_ar' },
        { label: 'title English', key: 'title_en' },
        { label: 'Image', key: 'main_image' },
      ],
    };
  },

  async created() {
    await this.fetchDoctors();
  },
  computed: {
    filteredDoctors() {
      if (!this.searchTerm) {
        return this.doctors;
      }
      const term = this.searchTerm.toLowerCase();
      return this.doctors.filter(
        (doctor) =>
          doctor.name.toLowerCase().includes(term) ||
          doctor.postal_code.toLowerCase().includes(term)
      );
    },
  },

  methods: {
    // fetch doctors
    async fetchDoctors() {
      try {
        const response = await axios.get(
          `/admin/admin/doctor/get-delete-soft`
        );
        this.doctors = response.data.data;
        this.meta = response.data.meta;
        this.$nextTick(() => {
          this.initializeDataTable(); // Initialize DataTable after fetching users
        });
      } catch (error) {
        console.error("Error fetching doctors:", error);
      }
    },
    initializeDataTable() {
      this.$nextTick(() => {
        // Ensure the DataTable is initialized only after the DOM is updated
        $('.sample_1').DataTable(); // Initialize DataTable
      });
    },
    restoreDoctor(id) {
      console.log("restore doctor id: ", id);
      axios
        .post(`/admin/admin/doctor/restore?id=${id}`)
        .then((response) => {
          console.log(response.data);
          this.fetchDoctors();
        })
        .catch((error) => {
          console.error(error);
        });
    },

  },
};
</script>
<style scoped>
.table {
  margin-top: 10px;
}

.spacing {
  margin-left: 10px !important;
}
</style>
